import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import { HomeyApiContext } from "lib/HomeyApiContext";

import MqttClient from "lib/mqtt-client";
import {
  getAircareData,
  getWeatherData,
  getRHLevel,
  getCO2Level,
  getPMLevel,
  getTempLevel,
} from "../utils";

import AirQualityCard from "components/dashboard/AirQualityCard";

const Dashboard = ({userInfo}) => {
  const { homeyApi } = useContext(HomeyApiContext);
  const homeyApiRef = useRef(null);
  const [capabilities, setCapabilities] = useState(null);
  const [airStats, setAirStats] = useState([]);
  // const [prevCapas, setPrevCapas] = useState(null);
  const [visible, setVisible] = useState(false);
  const [mqttClient, setMqttClient] = useState(null);

  const capa_meta = [
    { id: "measure_co2", title: "CO₂", unit: "ppm", summary: "co2", quality_fn: getCO2Level },
    { id: "measure_pm25", title: "PM2.5", unit: "㎍/m³", summary: "indoor_pm", quality_fn: getPMLevel },
    { id: "measure_temperature", title: "온도", unit: "°C", summary: "indoor_temp", quality_fn: getTempLevel },
    { id: "measure_humidity", title: "습도", unit: "%", summary: "indoor_rh", quality_fn: getRHLevel },
  ]

  const fetchSummary = async () => {
    if (userInfo?.remoteUrl) {
      const { summary } = await getAircareData(userInfo.remoteUrl);
      return summary;
    }
  };

  const fetchCapabilities = async () => {
    const api = homeyApiRef.current
    if (!api) return;

    try {
      const devicesObj = await api.devices.getDevices();
      const devices = Object.values(devicesObj);
      const airSensorDevice = devices.find(
        (d) => d.name?.trim() === "Enhanced aircare sensor"
      );
      const deviceId = airSensorDevice.id;
      const entries = await Promise.all(
        capa_meta.map(async (c) => {
          const value = await api.devices.getCapabilityValue({ deviceId, capabilityId: c.id });
          return [c.id, value];
        })
      );

      const capasObject = Object.fromEntries(entries);
      setCapabilities(capasObject);
    } catch (err) {
      console.error("fetchCapabilities error:", err);
    }
  };

  useEffect(() => {
    homeyApiRef.current = homeyApi;
    fetchCapabilities();
  }, [homeyApi]);

  useEffect(() => {
    const MQTT_BROKER = "ws://211.61.18.17:9001";
    const client = new MqttClient(MQTT_BROKER);
    setMqttClient(client);
    client.connect();

    return () => client.disconnect();
  }, []);

  // polling
  useEffect(() => {
    const interval = setInterval(() => {
      fetchCapabilities();
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchDashboard = async () => {
      // setPrevCapas(capabilities);
      if (!capabilities || !userInfo || !userInfo.remoteUrl) return;
      const { summary: summaryEntry } = await getAircareData(userInfo.remoteUrl);
      const { forecast, temperature, state } = await getWeatherData(userInfo.remoteUrl);
      const weather = { forecast, temperature, state };

      // TEMP
      const data = {current: capabilities, summary: summaryEntry, weather: weather}
      mqttClient.sendMessage("homey/air/summary", JSON.stringify(data));

      const stats = capa_meta.map((meta) => {
        const summary = summaryEntry[meta.summary];
        const current = capabilities[meta.id];
        const title = meta.title;
        const unit = meta.unit;
        const percent = meta.id === "measure_humidity" ? current : null;
        const lastWeek = summary.basic_stats.week.mean;
        const previous = summary.basic_stats.hour.mean[23].value;
        const trend = ((current - previous) / previous) * 100;
        return { title, unit, value: current, percent, trend: trend.toFixed(1), last: lastWeek.toFixed(0), quality_fn: meta.quality_fn};
      });
      setAirStats(stats);
    };
    fetchDashboard();
  }, [capabilities]);

  useEffect(() => {
    setVisible(airStats.length != 0);
  }, [airStats]);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "nowrap",
        gap: "1rem",
        justifyContent: "flex-start",
        marginBottom: "1.5rem",
        opacity: visible ? 1 : 0,
        transition: "opacity 1s ease-in",
        overflowX: "auto",
      }}
    >
      {userInfo && airStats.map((stat, index) => (
        <AirQualityCard key={index} {...stat} />
      ))}
    </div>
  );
};

export default Dashboard;
